class Enum {
    static GetAll(){
        let ris = [];
        for(let p in this){
            ris.push(this[p]);
        }
        return ris;
    }
    static GetDictionary(){
        let ris = {};
        for(let p in this){
            ris[p] = this[p];
        }
        return ris;
    }
}

export class RoutesGroup extends Enum {
    static Performance: RoutesGroupConfig = { text: "Performance", order: 1 };
    static Marketing: RoutesGroupConfig = { text: "Marketing", order: 2 };
    static Gestione: RoutesGroupConfig = { text: "Gestione", order: 3 };
    static Utenze: RoutesGroupConfig = { text: "Utenze", order: 4 };
    static Configurazione: RoutesGroupConfig = { text: "Configurazione", order: 5 };
}
class RoutesGroupConfig {
    text: string;
    order: number;
}

export class DayOfWeek extends Enum
{
    static Sunday: string = "0";
    static Monday: string = "1";
    static Tuesday: string = "2";
    static Wednesday: string = "3";
    static Thursday: string = "4";
    static Friday: string = "5";
    static Saturday: string = "6";
}

export class SurveyType extends Enum
{
    static Assessment: string = "Assessment";
    static Internal: string = "Internal";
}

export class UserTypes extends Enum
{
    static Lead: string = "Lead";
    static Customer: string = "Customer";
    static Operator: string = "Operator";
    static Doctor: string = "Doctor";
}

export class Sesso
{
    static Maschio: string = "Maschio";
    static Femmina: string = "Femmina";
}

export class ModalitaPagamentoUser extends Enum {
    static Bonifico: string = "Bonifico";
    static Paypal: string = "Paypal";
    static Revolut: string = "Revolut";
}

export class PaymentMethods extends Enum {
    static Stripe: string = "Stripe";
    static Bonifico: string = "Bonifico";
    static Crypto: string = "Crypto";
    static Contanti: string = "Contanti";
    static Manuale: string = "Manuale";
    static Saldo: string = "Saldo";
}

export class PaymentRequestTimePeriod extends Enum {
    static Monthly: string = "Monthly";
    static Weekly: string = "Weekly";
}

export class PaymentRequestType extends Enum
{
    static Crypto: string = "Crypto";
    static WireTransfer: string = "WireTransfer";
    static CardNumber: string = "CardNumber";
    static Email: string = "Email";
}

export class PaymentMethodType extends Enum
{
    static Deferred: string = "Deferred";
    static Stripe: string = "Stripe";
    static Saldo: string = "Saldo";
}

export class QualificationPeriodType extends Enum
{
    static Monthly: string = "Monthly";
    static ThreeMonths: string = "ThreeMonths";
    static SixMonths: string = "SixMonths";
    static Annually: string = "Annually";
}